import { login, getUserInfo } from '@/api/user';
import { getToken, setToken, removeToken, getUserId, setUserId, removeUserId } from '@/utils/auth';
import store from '../index';

const state = {
  token: getToken(),
  userId: getUserId(),
  name: '',
  userInfo: {},
  perms: [] // 用户权限标识集合
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERID: (state, userId) => {
    state.userId = userId;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_PERMS(state, perms) {
    // 用户权限标识集合
    state.perms = perms;
  }
};

const actions = {
  // 登录
  login({ commit }, loginForm) {
    const { userName, password } = loginForm;
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await login({ loginName: userName.trim(), password: password });
        commit('SET_TOKEN', data.token);
        setToken(data.token);
        commit('SET_USERID', data.id);
        setUserId(data.id);
        commit('SET_NAME', data.name);
        commit('SET_USERINFO', data);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  // 获取用户信息
  getUserInfo({ commit, state }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getUserInfo(state.userId);
        commit('SET_NAME', data.name);
        commit('SET_USERINFO', data);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  // 退出 清除用户信息
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', '');
      removeToken();
      commit('SET_USERID', '');
      removeUserId();
      commit('SET_PERMS', []);
      commit('SET_USERINFO', {});
      dispatch('tagsView/delAllViews', null, { root: true });
      store.commit('app/menuRouteLoaded', false);
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
